import React, { Component, PropTypes } from 'react'
import { connect } from 'react-redux'
import { chain } from 'lodash'
import config from '../../config'
import Loader from 'react-loader'
import CSSModules from 'react-css-modules'
import format from '../../helpers/format'
import { asyncConnect } from 'redux-async-connect'
import container from '../../helpers/container'
import convert from '../../helpers/convert'
import analytics from '../../helpers/analytics'
import { Row, Col } from 'react-flexbox-grid'
import chroma from 'chroma-js'
import { SlideDown } from 'react-slidedown'
import {
  ContainerDivs,
  Chart,
  FlaggedFund,
  Link,
  LinkIcon,
  Grade,
  Tweeter,
  InlineSignup,
  FundMenu,
  FundName,
  FundShareTakeAction,
  IyvScorecard,
  CompanyLogos,
  // AssetManagerLetter
} from '../../components'
import * as searchActions from 'redux/modules/search'
import Styles from './FundFossilFuelInvestments.css'

// we could do pagination a few at a time, but we'll do click to show all
const FirstPage = 5
const AllPage = 1000000

function mapFundHoldings(fHoldings){
  const fHoldingsMap = {}
  fHoldings.forEach((fholding)=>{
    fHoldingsMap[fholding.db_holding_id] = fholding
  })
  return fHoldingsMap
}

function filterHoldings(fHoldingsMap, holdings, filterFn){
  // console.log('filtering holdings!!')
  // console.log(filterFn)
  return chain(holdings)
    .filter(filterFn)
    .sortBy((o)=>{ return fHoldingsMap[o.id].market_value * -1 })
    // .take(10)
    .value()
}


@CSSModules(Styles, {allowMultiple:true})
class SectorDetailsSwitches extends Component {
  static propTypes = {
    clickSector: PropTypes.func,
    increment: PropTypes.func,
    sector: PropTypes.array,
    fund: PropTypes.object,
    shareClass: PropTypes.object,
    fHoldingsMap: PropTypes.object,
    activeSector: PropTypes.string,
    fossilsPage: PropTypes.number,
  }

  constructor(props){
    super(props)
  }

  render(){
    const {
      clickSector,
      increment,
      sector,
      fund,
      shareClass,
      fHoldingsMap,
      activeSector,
      fossilsPage
    } = this.props

    //
    return (
      <div id={'sector-id-'+sector[0]}>
        <SectorDetailsSwitch
          clickSector={clickSector}
          type={sector[0]}
          label={sector[1]}
          sublabel={sector[2]}
          count={fund[sector[3]]}
          weight={fund[sector[4]]}
          asset={fund[sector[5]]}
          currency={shareClass.currency}
          activeSector={activeSector}
        >
          <SlideDown>
            { /* render the holding list if the sector is active */
              activeSector === sector[0] ?
                <HoldingsListDisplay
                  increment={increment}
                  shareClass={shareClass}
                  fHoldingsMap={fHoldingsMap}
                  type={sector[0]}
                  label={sector[1]}
                  count={shareClass[sector[3]]}
                  holdings={sector[6]}
                  page={fossilsPage}
                /> :
                null
            }
          </SlideDown>
        </SectorDetailsSwitch>
      </div>
    )
  }
}


@CSSModules(Styles, {allowMultiple:true})
class SectorDetailsSwitch extends Component {
  static propTypes = {
    clickSector: PropTypes.func,
    type: PropTypes.string,
    label: PropTypes.string,
    sublabel: PropTypes.string,
    count: PropTypes.string,
    weight: PropTypes.string,
    asset: PropTypes.string,
    currency: PropTypes.string,
    activeSector: PropTypes.string
  }

  constructor(props){
    super(props)
  }

  render(){
    const {
      clickSector,
      type,
      label,
      sublabel,
      count,
      weight,
      asset,
      currency,
      activeSector
    } = this.props

    // images
    // circle icon
    const iconUnfilled = require(`../../../static/images/icn-${type}.svg`)
    // circle icon filled in
    const iconFilled = require(
      `../../../static/images/icn-${type}-active.svg`
    )
    // circle icon inactive
    const iconGrey = require(
      `../../../static/images/icn-${type}-inactive.svg`
    )

    // clean or dirty?
    const isDirty = (convert.int(count))
    // currently active?
    const isActive = (type === activeSector)
    // what style?
    let currIcon = null
    let cleanDirtyStyle = ''

    if (isDirty) {
      if (isActive){
        cleanDirtyStyle = 'detail-sector-'+type+'-active'
        currIcon = iconFilled
      } else {
        cleanDirtyStyle = 'detail-sector-'+type+'-normal'
        currIcon = iconUnfilled
      }
    } else {
      cleanDirtyStyle = 'detail-sector-clean'
      currIcon = iconGrey
    }

    //
    return (
      <div styleName={'detail-sector-wrapper ' + cleanDirtyStyle}>
        <div
          onClick={
            () => { clickSector(type, isDirty) }
          }
        >
          <div styleName='detail-sector-detail-flex'> { /* styleName={cleanDirtyStyle} */ }
            <div styleName='detail-sector-detail-icon-wrap'>
              <img
                styleName='detail-icon'
                src={currIcon}
                alt={label}
              />
            </div>
            <div styleName='detail-title-active'>
              <div><b>{label}</b></div>

              {
                sublabel ?
                  (
                    <div styleName='detail-sublabel'>
                      {sublabel}
                    </div>
                  ) :
                  null
              }

            </div>

            { /* if dirty, render sector stats. else, render a badge */
              isDirty ?
                (
                  <div styleName='detail-sector-stat-wrapper'>
                    <div styleName='detail-stat-active'>
                      <div styleName='detail-stat-figure'>
                        {format.number(count)}
                      </div>
                      <div styleName='detail-stat-label'>holdings</div>
                    </div>
                    <div styleName='detail-stat-active'>
                      <div styleName='detail-stat-figure'>
                        {format.money(asset, true, currency, true)}
                      </div>
                      <div styleName='detail-stat-label'>invested</div>
                    </div>
                    <div styleName='detail-stat-active'>
                      <div styleName='detail-stat-figure'>
                        {format.perc(weight)}
                      </div>
                      <div styleName='detail-stat-label'>of portfolio</div>
                    </div>
                  </div>
                ) :
                (
                  <div styleName='single-badge-wrap'>
                    <div styleName='single-badge-text'>
                      <div styleName='single-badge-subtitle'>
                        No direct stock holdings
                      </div>
                    </div>
                  </div>
                )
            }
          </div>
        </div>

        { this.props.children }
      </div>

    )
  }
}


@CSSModules(Styles, {allowMultiple:true})
class HoldingsListDisplay extends Component {
  static propTypes = {
    increment: PropTypes.func,
    shareClass: PropTypes.object,
    fHoldingsMap: PropTypes.object,
    type: PropTypes.string,
    label: PropTypes.string,
    count: PropTypes.string,
    holdings: PropTypes.array,
    page: PropTypes.number
  }

  constructor(props){
    super(props)
  }

  render(){
    const {
      increment,
      shareClass,
      fHoldingsMap,
      type,
      label,
      count,
      holdings,
      page
    } = this.props

    const _count = convert.int(count)
    const hasMoreButton = (page === 1 && _count > FirstPage) ?
      (
        <div
          styleName={'detail-more-'+type}
          onClick={increment(type === 'fossils' ? 'fossilsPage' : 'sectorPage')}
        >
          See all
        </div>
      ) :
      null

    if (_count === 0) {
      return null
    }

    const holdingsCountString = format.number(_count) + ' holdings'

    //
    return (
      <Col xs={12} styleName='detail-holdings-wrapper'>
        <div styleName='detail-fossils'>
          {
            type === 'fossils' ?
              <div styleName='detail-title-holdings'>
                <div styleName={'detail-title-' + type}>
                  {label}
                </div>
                <div
                  styleName={
                    'visible-sm visible-md visible-lg ' +
                      'detail-holdings-count-' + type
                  }
                >
                  {holdingsCountString}
                </div>
                <div styleName='visible-xs mobile-holdings-label'>
                  {holdingsCountString}
                </div>
              </div> :
              null
          }
          <HoldingsList
            shareClass={shareClass}
            fHoldingsMap={fHoldingsMap}
            holdings={holdings}
            page={page}
          />
        </div>
        <div style={{textAlign: 'right'}}>
          {hasMoreButton}
        </div>
      </Col>
    )
  }
}


@CSSModules(Styles, {allowMultiple:true})
class HoldingsList extends Component {
  static propTypes = {
    shareClass: PropTypes.object,
    fHoldingsMap: PropTypes.object,
    holdings: PropTypes.array,
    page: PropTypes.number
  }

  constructor(props){
    super(props)
  }

  render(){
    const { shareClass, fHoldingsMap, holdings, page } = this.props

    if (!holdings || holdings.length === 0) {
      return (
        <div styleName='holdings-none'>NONE</div>
      )
    }

    const takeCount = (page > 1) ? AllPage : FirstPage

    // images
    const iconC2 = require( '../../../static/images/icn-c2-active.svg' )
    const iconCo = require( '../../../static/images/icn-co-active.svg' )
    const iconOg = require( '../../../static/images/icn-og-active.svg' )
    const iconF5 = require( '../../../static/images/icn-f5-active.svg' )
    const iconUt = require( '../../../static/images/icn-ut-active.svg' )

    const iconConfigs = [
      ['is_c2', iconC2, 'Carbon Underground 200'],
      ['is_co', iconCo, 'Coal industry'],
      ['is_og', iconOg, 'Oil/gas industry'],
      ['is_f15', iconF5, 'Macroclimate 50'],
      ['is_ut', iconUt, 'Fossil-fired utility']
    ]

    return (
      <ul styleName='detail-holdings'>
        {
          chain(holdings)
            .take(takeCount)
            .map((h, idx) => {
              // useful formats
              const fPerc = format.perc(fHoldingsMap[h.id].long_weight)
              const fMoney = format.money(
                fHoldingsMap[h.id].market_value,
                true,
                shareClass.currency,
                true
              )

              //
              return (
                <li key={idx} styleName='holding'>
                  <div styleName='holding-name'>
                    <div>{idx+1}. {h.security_name}</div>
                    <div>
                      { /* mini-sector icons */
                        iconConfigs.map((sector)=>{
                          return h[sector[0]] ?
                            (
                              <span
                                key={sector[0]}
                                title={sector[2]}
                              >
                                <img
                                  styleName='detail-icon-holding'
                                  src={sector[1]}
                                  alt={sector[2]}
                                />
                              </span>
                            ) :
                            null
                        })
                      }
                    </div>
                  </div>
                  <div styleName='holding-invested'>
                    {fMoney}
                  </div>
                  <div styleName='holding-asset'>
                    {fPerc}
                  </div>
                </li>
              )
            })
            .value()
        }
      </ul>
    )
  }
}


@CSSModules(Styles, {allowMultiple:true})
class GradeBox extends Component {
  static propTypes = {
    shareclass: PropTypes.object.isRequired
    // gradeFossil: PropTypes.number,
    // ffWeight: PropTypes.string,
  }

  constructor(props){
    super(props)
  }

  render(){
    // gradebar image
    const GR = format.score(this.props.shareclass.grade_fossil)
    const gr = GR.toLowerCase()
    // const gradeBar = require(`../../../static/images/bar-fff-${gr}.jpg`)

    const tip = format.fossilFuelInvestmentsGradeDescription(
      convert.float(this.props.shareclass.c2f5coogutweight),
      GR,
      this.props.shareclass.fund_legal_name,
      this.props.shareclass.ticker,
      this.props.shareclass.fund_id,
      this.props.shareclass.investment_vehicle_id,
    )

    //
    return (
      <div styleName={'grade-snapshot-'+gr}>
        <div>
          <div styleName='grade-intro'>
            <div styleName='grade-intro-tip'>
              {tip}
            </div>
            <br/>
            <Link
              strong
              to={config.routes.howitworks}
              title='How it works'
            >
              <b>Methodology<LinkIcon /></b>
            </Link>
          </div>
        </div>
        <div styleName='grade-wrapper'>
          <Grade
            grade={this.props.shareclass.grade_fossil}
            large
          />
        </div>
      </div>
    )
  }
}


@connect(
  state => ({
    result: state.shareClass.result,
    loading: state.shareClass.loading,
    loaded: state.shareClass.loaded,
    error: state.shareClass.error
  }),
  searchActions
)

@asyncConnect([{
  deferred: true, // need otherwise cient navigate blocked until page loaded
  promise: ({params, store: {dispatch, getState}}) => {
    return dispatch(
      searchActions.shareClassDetails(
        params.fundId,
        params.investmentVehicleId
      )
    )
  }
}])

@CSSModules(Styles, {allowMultiple:true})
export default class FundFossilFuelInvestments extends Component {
  static propTypes = {
    loading: PropTypes.bool,
    loaded: PropTypes.bool,
    error: PropTypes.object,
    result: PropTypes.object
  }

  static contextTypes = {
    router: PropTypes.object.isRequired
  }

  constructor(props){
    super(props)
    this.increment = this.increment.bind(this)
    this.clickSector = this.clickSector.bind(this)
    this.state = {
      fossilsPage: 1,
      sectorPage: 1,
      activeSector: '' // '',
    }
  }

  componentWillMount(){
    if (typeof window !== 'undefined') {
      window.scrollTo(0,0)
    }
  }

  componentDidMount(){
    // window.addEventListener('scroll', this.handleScroll)
    analytics.event(
      analytics.eventLoadFund(
        this.props.params.fundId,
        this.props.params.investmentVehicleId
      )
    )
  }

  componentWillReceiveProps(nextProps){
    // console.log('componentWillReceiveProps')
    // console.log(nextProps)
  }

  getChartData = (fund, fossilFuelHoldings, fHoldingsMap) => {
    // colors
    const colors = {
      'c2' : '#D2371B',
      'c2end' : '#FF8872',
      'co' : '#A9240B',
      'coend' : '#E3624A',
      'og' : '#821400',
      'ogend' : '#C74A33',
      'f5' : '#A95C0B',
      'f5end' : '#E3984A',
      'ut' : '#824300',
      'utend' : '#C77F33',
      'fossil' : '#333',
      'gray' : '#D5D5D5',
      'green' : '#149A43'
    }

    // what categories are active?
    const activeSector = this.state.activeSector
    const ffAsset = convert.int(fund.c2f5coogutasset)
    const ffWeight = format.perc(fund.c2f5coogutweight)
    let chartData = []

    if (activeSector && ffAsset > 0) {
      // companies
      const num_colors = convert.int(fund[activeSector+'count'])
      const scaleStart = colors[activeSector]
      const scaleEnd = colors[activeSector+'end']
      const f = chroma.scale([scaleStart,scaleEnd]).mode('rgb').colors(num_colors)
      // const shuffled = format.shuffle(f)
      let currIdx = -1
      // // map holdings to pie chart data
      chartData = fossilFuelHoldings.reduce((filtered, holding) => {
        const nameLabel = format.longString(holding.security_name, 20)
        const moneyLabel = format.money(
          fHoldingsMap[holding.id].market_value,
          true,
          'USD',
          true
        )
        currIdx = (currIdx + 1) % num_colors
        filtered.push({
          value: fHoldingsMap[holding.id].market_value,
          label: nameLabel + ' ' + moneyLabel,
          color: f[currIdx]
        })
        return filtered
      }, [])
    } else {
      if (ffAsset > 0) {
        chartData = [
          {
            value: ffAsset,
            label: 'Fossil fuel stocks: ' + ffWeight,
            color: colors.fossil
          },
          {
            value: convert.int(fund.fund_net_assets) - ffAsset,
            label: 'All other holdings',
            color: colors.gray
          }
        ]
      } else {
        chartData = [
          {
            value: 1,
            label: 'No Fossil Fuel Stock Holdings',
            color: colors.gray
          }
        ]
      }
    }
    return chartData
  }

  clickSector = (newSector, isDirty) => {
    if (isDirty) {
      const sectorIsActive = newSector === this.state.activeSector
      // this.scrollTo('sector-id-'+newSector)()
      this.setState({
        activeSector: sectorIsActive ? '' : newSector,
        sectorPage: 1
      })
    }
  }

  handleScroll = () => {
    // if ( !this.props.result ) { return }
    // const scrollTop = event.srcElement.body.scrollTop
  }

  // need this solution since asyncConnect and anchor links does not play nice
  scrollTo = (id) => {
    return () => {
      const ele = document.getElementById(id)
      // console.log('scrolling to:', id)
      // console.log(ele)
      window.scrollTo(ele.offsetLeft, ele.offsetTop)
    }
  }

  increment = (incState) => {
    return () => {
      const newState = {}
      newState[incState] = this.state[incState] + 1
      this.setState(newState)
    }
  }

  render(){
    // loading icons
    if (!this.props.result) {
      return (
        <div styleName='main'>
          <Loader
            options={{scale: 0.70, top:'2.0rem'}}
            loaded={false}
          />
        </div>
      )
    } else if (
      this.props.result &&
      (
        !this.props.result.fund ||
        !this.props.result.shareClass
      )
    ) {
      this.context.router.push(config.routes.notFound)
      return (
        <div styleName='main'>
          <Loader
            options={{scale: 0.70, top:'2.0rem'}}
            loaded={false}
          />
        </div>
      )
    }

    const { fund, shareClass } = this.props.result
    const { holdings, fundholdings } = fund
    const title = shareClass.fund_legal_name + ' | Fossil fuel investments'
    const url = config.domain + this.props.location.pathname

    // dividing up holdings by sector groups
    // could this be cached (e.g. in state) to improve performance?
    const fHoldingsMap = mapFundHoldings(fundholdings)
    const fossilFuelHoldings = filterHoldings(
      fHoldingsMap,
      holdings,
      (o)=>{ return (
        o.is_c2  || o.is_co  || o.is_og  || o.is_f15 || o.is_ut
      ) }
    )
    const c2Holdings = filterHoldings(
      fHoldingsMap, holdings, (h)=>{ return(h.is_c2) }
    )
    const f5Holdings = filterHoldings(
      fHoldingsMap, holdings, (h)=>{ return(h.is_f15) }
    )
    const coHoldings = filterHoldings(
      fHoldingsMap, holdings, (h)=>{ return(h.is_co) }
    )
    const ogHoldings = filterHoldings(
      fHoldingsMap, holdings, (h)=>{ return(h.is_og) }
    )
    const utHoldings = filterHoldings(
      fHoldingsMap, holdings, (h)=>{ return(h.is_ut) }
    )

    // configs for donut charts
    // Config is:
    // [
    //   active sector in state (c2, co, etc.),
    //   amount intested (c2asset, etc.)
    //   list of holdings for that screen list,
    //   text label for humans
    // ]
    const chartConfigs = [
      ['', 'c2f5coogutasset', fossilFuelHoldings, ''],
      ['c2', 'c2asset', c2Holdings, 'Carbon Underground 200'],
      ['co', 'coasset', coHoldings, 'Coal industry'],
      ['og', 'ogasset', ogHoldings, 'Oil/gas industry'],
      ['f5', 'f5asset', f5Holdings, 'Macroclimate 50'],
      ['ut', 'utasset', utHoldings, 'Fossil-fired utilities']
    ]

    // configs for "sector switch" totals and holdings lists
    const producersSectorConfig = [
      [
        'c2',
        'Top 200 owners of carbon reserves',
        'Carbon Underground 200',
        'c2count',
        'c2weight',
        'c2asset',
        c2Holdings
      ],
      [
        'co',
        'Coal industry',
        'Coal miners, coal services, owners of coal reserves',
        'cocount',
        'coweight',
        'coasset',
        coHoldings
      ],
      [
        'og',
        'Oil/gas industry',
        'Oil/gas producers and refiners, oil field services and equipment ' +
          'companies, pipeline operators',
        'ogcount',
        'ogweight',
        'ogasset',
        ogHoldings
      ]
    ]

    const consumersSectorConfig = [
      [
        'f5',
        'Top 50 coal-fired utilities',
        'Macroclimate 50',
        'f5count',
        'f5weight',
        'f5asset',
        f5Holdings
      ],
      [
        'ut',
        'Fossil-fired utilities',
        'Utilities burning fossil fuels or distributing gas',
        'utcount',
        'utweight',
        'utasset',
        utHoldings
      ]
    ]

    // useful converts
    const isSRI = convert.boolean(fund.socially_responsible_fund || '0')
    // const isUSSIF = fund.ussif === '1.5'
    const ffCount = convert.int(fund.c2f5coogutcount)
    const ffAsset = convert.int(fund.c2f5coogutasset)
    const ffWeight = convert.float(fund.c2f5coogutweight)
    const c2Count = convert.int(fund.c2count)
    const f5Count = convert.int(fund.f5count)

    const _ticker = shareClass.ticker || null
    let fundName = `${fund.fund_legal_name}`
    fundName = _ticker ? `${fundName} ${_ticker}` : fundName
    const _ffAsset = format.money(ffAsset, true, 'USD', false)
    const _ffWeight = format.perc(ffWeight)
    const description = `${fundName} has ${_ffAsset} invested in fossil fuels, ${_ffWeight} of the fund`

    return (
      <div>
        {container.helmet(title, description, url)}

        <div styleName='fossil-fuel-banner-wrap'>
          <ContainerDivs>
            <h2 styleName='fossil-fuel-banner-hl'>
              <span styleName='fossil-fuel-banner-hl-lg'>Fossil fuel companies</span>
              <span styleName='fossil-fuel-banner-hl-sm'>are fueling the climate crisis.</span>
            </h2>
          </ContainerDivs>
        </div>

        { /* FUND MENU COMPONENT */ }
        <br/>
        <FundMenu
          active='Fossil fuels'
          fundId={shareClass.fund_id}
          investmentVehicleId={shareClass.investment_vehicle_id}
          name={shareClass.fund_legal_name}
          ticker={shareClass.ticker}
        />

        { /* FUND NAME COMPONENT */ }
        <FundName
          shareClass={shareClass}
          pathname={this.props.location.pathname}
        />

        { /* temporary asset manager letter for Vanguard */ }
        { /* <AssetManagerLetter fundFamilyName={fund.fund_family_name}/> */ }

        <div styleName='main'>
          <div styleName='snapshot-wrapper'>
            <div styleName='snapshot'>
              <Row>
                <Col xs={12} sm={12} md={4} styleName='chart-sidebar-wrap'>

                  <GradeBox shareclass={shareClass} />

                  <div styleName='sticky-sidebar'>
                    { /* Sector donut charts */
                      chartConfigs.map((sector) => {
                        return (
                          this.state.activeSector === sector[0] ?
                            (
                              <Chart
                                key={sector[1]}
                                currency={shareClass.currency}
                                invested={convert.int(fund[sector[1]])}
                                chartData={
                                  this.getChartData(
                                    fund,
                                    sector[2],
                                    fHoldingsMap
                                  )
                                }
                                chartMessage={sector[3]}
                              />
                            ) :
                            null
                          )
                      })
                    }

                    { /* FLAGGED FUND COMPONENT */ }
                    <FlaggedFund
                      count={ffCount}
                      weight={ffWeight}
                      asset={ffAsset}
                      portfolioDate={fund.date}
                    />
                  </div>

                </Col>
                <Col xs={12} sm={12} md={8} styleName='main-content-wrap'>

                  { /* SRI + 5-Badger special congrats */
                    fund.grade_fossil === 1 && isSRI ?
                      <div styleName='flagged-fund-clean'>
                        <LinkIcon faclass='fa-leaf' nospace/>
                        &nbsp;
                        A grade + sustainability mandate
                      </div> :
                      null
                  }

                  {
                    ffCount && (c2Count || f5Count) ?
                      <div styleName='sector-details-headline-upper'>
                        Investments in major fossil fuel companies
                      </div> :
                      null
                  }

                  {
                    ffCount && (c2Count || f5Count) ?
                      <CompanyLogos
                        holdings={fossilFuelHoldings}
                        fHoldingsMap={fHoldingsMap}
                      /> :
                      null
                  }

                  <div styleName='sector-details-headline-lower'>
                    Fossil fuel holdings
                  </div>

                  { /* PRODUCER HOLDINGS TOTALS AND LISTS */ }
                  <div styleName='sector-details-info-label-energy'>
                    Energy sector
                  </div>

                  { /* Producer sector switches + company lists */
                    producersSectorConfig.map((sector)=>{
                      return <SectorDetailsSwitches
                        key={sector[0]}
                        clickSector={this.clickSector}
                        increment={this.increment}
                        sector={sector}
                        fund={fund}
                        shareClass={shareClass}
                        fHoldingsMap={fHoldingsMap}
                        activeSector={this.state.activeSector}
                        fossilsPage={this.state.sectorPage}
                      />
                    })
                  }

                 { /* CONSUMERS HOLDINGS TOTALS AND LISTS */ }
                  <div styleName='sector-details-info-label-utility'>
                    Utility sector
                  </div>

                  { /* Utility sector switches + company lists */
                    consumersSectorConfig.map((sector)=>{
                      return <SectorDetailsSwitches
                        key={sector[0]}
                        clickSector={this.clickSector}
                        increment={this.increment}
                        sector={sector}
                        fund={fund}
                        shareClass={shareClass}
                        fHoldingsMap={fHoldingsMap}
                        activeSector={this.state.activeSector}
                        fossilsPage={this.state.sectorPage}
                      />
                    })
                  }

                  { /* EXPLANATION TEXT FOR HOLDINGS LISTS */ }
                  <div styleName='sector-details-info'>
                    <LinkIcon nospace faclass='fa-info-circle' />
                    &nbsp;
                    When calculating a portfolio's
                    screen exposure, we
                    only consider long investments, ignoring any shorts or
                    liabilities.
                  </div>

                  { /* All fossil fuel holdings list */
                    ffCount ?
                      <SlideDown>
                        <HoldingsListDisplay
                          increment={this.increment}
                          shareClass={shareClass}
                          fHoldingsMap={fHoldingsMap}
                          type={'fossils'}
                          label={'All fossil fuel companies'}
                          count={fund.c2f5coogutcount}
                          holdings={fossilFuelHoldings}
                          page={this.state.fossilsPage}
                        />
                      </SlideDown> :
                      null
                  }

                </Col>
              </Row>

              { /* TWEETER COMPONENT
              <div styleName='tweeter-wrap'>
                <div styleName='tweeter-cta'>
                  {
                    fund.c2f5coogutcount > 0 ?
                      <span>
                        <b>Share to spread the word.</b><br/>
                        Business as usual is fueling climate
                        destruction.
                      </span> :
                      <span>Share to spread the word.</span>
                  }
                </div>
                <Tweeter type='fund' item={shareClass}/>
              </div> */ }

              <br/>
              <br/>
              <br/>
              <InlineSignup />

            </div>
          </div>
        </div>

        { /* IYV REPORT CARD COMPONENT */ }
        <IyvScorecard fund={fund} shareClass={shareClass}/>
        
        { /* FUND TAKE ACTIONS COMPONENT */ }
        { /*
        <FundShareTakeAction shareClass={shareClass} url={url}/>
        */ }

        { /* FUND LOWER NAV COMPONENT */ }
        { /* <FundNext
          prev=''
          next='carbon-footprint'
          prevLabel=''
          nextLabel='Carbon footprint'
          ticker={shareClass.ticker}
          name={fund.fund_legal_name}
          fundId={fund.fund_id}
          investmentVehicleId={shareClass.investment_vehicle_id}
        /> */ }

      </div>
    )
  }
}
